import React, {useState} from "react";


import { DiGhostSmall } from "react-icons/di";
import { SiHiveBlockchain } from "react-icons/si";
import { BiCategory } from "react-icons/bi";
import { MdCollections, MdLocalOffer } from "react-icons/md";
import { RiMoneyDollarCircleFill, RiDeleteBin6Fill } from "react-icons/ri";
import { GiMultipleTargets } from "react-icons/gi";



const ExploreSidebar = () => {
    const [isOn, setIsOn] =  useState(false);
    return (
        <>
            <div className="_nft_expnew_sidebar_wrap">
                <div className="_nft_expnew_sidebar_top">
                    <ul className="_nft_expnew_sidebar_top_ul">
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                    <DiGhostSmall/>   
                                    All
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                    <SiHiveBlockchain/>   Blockchain
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                   <BiCategory/> Category
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0" className="sub-btn" onClick={()=>{setIsOn(!isOn)}}>
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                  <MdCollections/>  Collections
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                            <div  className={`sub-menu _nft_expnew_sidebar_top_sub_menu ${isOn?'d-block':''}`}>
                                <a href="#0" className="sub-item _nft_expnew_sidebar_top_sub_item">Sub Item 01</a>
                                <a href="#0" className="sub-item _nft_expnew_sidebar_top_sub_item">Sub Item 02</a>
                                <a href="#0" className="sub-item _nft_expnew_sidebar_top_sub_item">Sub Item 03</a>
                            </div>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                   <MdLocalOffer/> On sale
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                  <RiMoneyDollarCircleFill/>  Price range
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                  <GiMultipleTargets/>  Multichain
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={7} fill="none" viewBox="0 0 19 11">
                                        <path fill="#4C4D53" d="M3.03 1.024A1.476 1.476 0 1 0 .943 3.11L3.03 1.024Zm6.334 8.42-1.043 1.044c.576.576 1.51.576 2.087 0L9.364 9.445Zm8.421-6.334A1.476 1.476 0 0 0 15.7 1.024l2.086 2.086Zm-16.842 0 7.378 7.378 2.087-2.087L3.03 1.024.943 3.11Zm9.465 7.378 7.377-7.378L15.7 1.024 8.32 8.4l2.087 2.087Z" />
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                    </ul>
                </div>
                <div className="_nft_expnew_sidebar_bottom">
                    <ul className="_nft_expnew_sidebar_top_ul">
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_settings_sidebar_top_li_ic _filter">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={22} fill="none" viewBox="0 0 20 22">
                                        <path stroke="#808191" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth="1.8" d="M3.197 1.108h13.197c1.1 0 2 .9 2 2v2.2c0 .8-.5 1.8-1 2.299l-4.3 3.8c-.6.499-1 1.499-1 2.299v4.299c0 .6-.4 1.4-.899 1.7l-1.4.9c-1.3.799-3.099-.1-3.099-1.7v-5.3c0-.7-.4-1.599-.8-2.099L2.097 7.507c-.5-.5-.9-1.4-.9-2v-2.3c0-1.199.9-2.099 2-2.099Z" />
                                    </svg>
                                </span>
                                <span className="_nft_expnew_sidebar_top_li_txt">
                                    Latest
                                </span>
                            </a>
                        </li>
                        <hr className="_divider" />
                        <li className="_nft_expnew_sidebar_top_li">
                            <a href="#0">
                                <span className="_nft_expnew_sidebar_top_li_txt _clear_filter">
                                   <RiDeleteBin6Fill/> Clear Filter
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}
export default ExploreSidebar;